var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThumbsUpFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6325 2.73919C14.9495 2.25094 14.1058 2.44376 13.5984 2.90607L8.08594 7.92879L8.08622 21.75H18.0461C19.4226 21.75 20.5871 20.7323 20.7714 19.3682L21.7865 11.8542C22.0094 10.2041 20.7264 8.73599 19.0613 8.73599H16.035C16.7033 7.64032 17.0634 6.63896 17.1093 5.72936C17.1746 4.4337 16.5973 3.42889 15.6325 2.73919ZM4.34961 8.25C3.38311 8.25 2.59961 9.0335 2.59961 10V20C2.59961 20.9665 3.38311 21.75 4.34961 21.75H6.69336V8.25H4.34961Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUpFilled);
export default __webpack_public_path__ + "static/media/ThumbsUpFilled.9075aa6194a8001eb5dccf954fbc0d63.svg";
export { ForwardRef as ReactComponent };